module.exports = __webpack_public_path__ + "static/media/DM-Negative-Clip-2.e677d916.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success/DM-Negative-Clip-2.mp3
// module id = 132
// module chunks = 0